

































import { Component, Vue } from 'vue-property-decorator'
import BillboardList from '@/components/billboard/billboard-list/BillboardList.vue'
import GoBackButton from '@/components/generics/GoBackButton.vue'

@Component({
  name: 'BillboardPage',
  components: {
    BillboardList,
    GoBackButton
  }
})
export default class BillboardPage extends Vue {
  data() {
    return {}
  }
}
